/**
 * @generated SignedSource<<2b4eb0571fce1ef8fd65f68c0b8c5f47>>
 * @relayHash 5b1bd6b384c5f103e6a2ec731996ffaa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3320717119d2600c1d4bef2bb65f53a925706aea0fb526e16634f44953bb0429

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AppSelectorQuery$variables = Record<PropertyKey, never>;
export type AppSelectorQuery$data = {
  readonly me: {
    readonly user: {
      readonly accountId: string;
      readonly " $fragmentSpreads": FragmentRefs<"StudioFoundationsApp_AtlassianStudioFoundations_userDataFragment">;
    };
  };
  readonly notifications: {
    readonly " $fragmentSpreads": FragmentRefs<"StudioFoundationsApp_AtlassianStudioFoundations_notificationDataFragment">;
  } | null | undefined;
};
export type AppSelectorQuery = {
  response: AppSelectorQuery$data;
  variables: AppSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "accountId"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AppSelectorQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v0/*: any*/),
                  "action": "THROW",
                  "path": "me.user.accountId"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "StudioFoundationsApp_AtlassianStudioFoundations_userDataFragment"
                }
              ]
            },
            "action": "THROW",
            "path": "me.user"
          }
        ]
      },
      {
        "concreteType": "InfluentsNotificationQuery",
        "kind": "LinkedField",
        "name": "notifications",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "StudioFoundationsApp_AtlassianStudioFoundations_notificationDataFragment"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppSelectorQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v0/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isUser"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "email"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "locale"
                  }
                ],
                "type": "AtlassianAccountUser"
              },
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "InfluentsNotificationQuery",
        "kind": "LinkedField",
        "name": "notifications",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "unseenNotificationCount"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3320717119d2600c1d4bef2bb65f53a925706aea0fb526e16634f44953bb0429",
    "metadata": {},
    "name": "AppSelectorQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "34d00ad3d45d7f4f193a684d4829f137";

export default node;
